import { getHasRentalProduct, getHasRotDeduction } from 'components/Cart/selector';
import { RenderLabeledInput } from 'components/Shared/Form/inputs';
import { isMobile as getIsMobile } from 'components/Shared/responsive';
import { ToolTip } from 'components/Shared/ToolTip';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import { NO_ELEMENT, rm } from 'utils';
import * as rules from 'views/CheckoutPage/validation';
import { default as commonStyles, default as styles } from './styles.scss';

interface OwnProps {
  onBlur: () => void;
  isManual: boolean;
}

export const RentalForm = ({ onBlur, isManual }: OwnProps) => {
  const hasRentalProducts = useSelector(getHasRentalProduct);
  const hasRotDeduction = useSelector(getHasRotDeduction);
  const isMobile = useSelector(getIsMobile);

  const identityPattern = isMobile ? '[0-9]*' : rules.identityNumberRegexString;

  if (!hasRentalProducts || hasRotDeduction || !isManual) {
    return NO_ELEMENT;
  }

  return (
    <div>
      <div className={styles.rentalFormheader}>
        <strong>
          {rm('checkout_rental_identity_header')}{' '}
          <ToolTip text={rm('checkout_rental_identity_body')} />
        </strong>
      </div>
      <Fragment>
        <Field
          name="identityNumber"
          inputMode="numeric"
          pattern={identityPattern}
          validate={rules.identityNumber}
          className={commonStyles.input}
          component={RenderLabeledInput}
          props={{ customLabel: rm('checkout_identityheader_private') }}
          onBlur={onBlur}
        />
      </Fragment>
    </div>
  );
};
